module.exports = __webpack_public_path__ + "static/media/greenMoney.7a0fe969.svg";